import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class PasswordIsEmptyError extends CodedError {
  static get errorName() {
    return errorCodes.passwordIsEmptyError.code;
  }

  static status = errorCodes.passwordIsEmptyError.status;
  static message = `${errorCodes.passwordIsEmptyError.message} ${errorCodes.passwordIsEmptyError.code}`;

  constructor(message: string = errorCodes.passwordIsEmptyError.message) {
    super(message);
    this.code = errorCodes.passwordIsEmptyError.code;
    this.message = `${message} ${errorCodes.passwordIsEmptyError.code}`;
    this.name = errorCodes.passwordIsEmptyError.name;
    this.status = 422;
  }
}
